import React from "react"
import { Box } from "@mui/material"
import { CheckCircle, RadioButtonUnchecked } from "@mui/icons-material"
import cronosCruiserIcon from "src/assets/icons/cronos-cruiser.svg"
import useNftRarity from "src/hooks/BoostFarming/useNftRarity"

import Text from "../Text"

export const Nft: React.FC<{
  id: string
  imgUrl: string
  selected?: boolean
  disabled?: boolean
  onClick?: () => void
}> = ({ id, imgUrl, selected = false, disabled = false, onClick }) => {
  const { data: rarity } = useNftRarity(id)
  return (
    <Box
      sx={{
        gap: "12px",
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
      }}
      onClick={!disabled && onClick ? onClick : () => undefined}
    >
      <Box position="relative" width="100%">
        <NftImage imgUrl={imgUrl} />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            border: "4px solid",
            borderColor: selected ? "#009BE0" : "transparent",
          }}
        >
          {selected && (
            <CheckCircle
              color="primary"
              sx={{
                position: "absolute",
                right: 0,
              }}
            />
          )}
          {!selected && !disabled && (
            <RadioButtonUnchecked
              sx={{
                position: "absolute",
                right: 0,
              }}
            />
          )}
        </Box>
      </Box>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mt={1}
      >
        <Text size="small">#{id}</Text>
        <Text size="small">{rarity}</Text>
      </Box>
    </Box>
  )
}

export const NftImage: React.FC<{
  imgUrl: string
}> = ({ imgUrl }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        paddingBottom: "100%",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          backgroundImage: `url(${cronosCruiserIcon})`,
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <img src={imgUrl} width="100%" height="auto" />
      </Box>
    </Box>
  )
}

export const NftInfo: React.FC<{
  id: string
  imgUrl: string
}> = ({ id, imgUrl }) => {
  const { data: rarity } = useNftRarity(id)
  return (
    <Box
      sx={{
        gap: "12px",
      }}
    >
      <NftImage imgUrl={imgUrl} />
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mt={1}
      >
        <Text size="small">#{id}</Text>
        <Text size="small">{rarity}</Text>
      </Box>
    </Box>
  )
}
